export default {
  BulkEditUserBillableRatesModal: () => import('./BulkEditUserBillableRatesModal/BulkEditUserBillableRatesModal.vue'),
  BudgetUserRatesModal: () => import('./BudgetUserRatesModal/BudgetUserRatesModal.vue'),
  ProjectBillableRatesModal: () => import('./ProjectBillableRatesModal/ProjectBillableRatesModal.vue'),
};
